// extracted by mini-css-extract-plugin
module.exports = {"videoButton":"ViewVideo_videoButton__Fm3sx"};